import { useTechClock, useTechLive } from "../../core/TechLive"
import Icon from "../base/Icon"
import TechLocationFreshnessLabel, { useTechLocationTone } from "../tech/TechLocationFreshness"
import TechLocationAccessLabel from "../tech/TechLocationAccessLabel"
import { useTechDeviceState } from "../../core/TechLive"
import { locationWords } from "../tech/TechDeviceWords"
import User from "../../modules/accounts/models/User"

/**
 * Where the technician stands right now, one line each under their name at the top of their
 * page: on the clock or not, how fresh their position is, and what their phone allows with
 * location (the battery sits beside the name) — the same answers the map's panel gives, live
 * from the same source.
 */
export default function AccountTechStatusStrip(props: { tech?: User }) {

    const techId = props.tech?.id
    const clock = useTechClock(techId)
    const live = useTechLive(techId)
    const device = useTechDeviceState(techId)

    const lastUpdate = live?.at ?? (props.tech?.techLocation ? props.tech?.techLocationLastUpdate : undefined)
    const isWakeup = !live && !props.tech?.techLocation
    const freshnessTone = useTechLocationTone(techId, lastUpdate, isWakeup)
    const accessTone = (device?.locationStatus ? locationWords[device.locationStatus]?.tone : undefined) ?? "gray-500"

    const onClock = clock?.on === true

    return (
        <div className="d-flex flex-column align-items-start mt-5 fs-7" style={{ gap: 8 }}>
            <span className={`d-inline-flex align-items-center fw-semibold text-${onClock ? "success" : "gray-500"}`}>
                <Icon icon="user-clock" type="regular" size={14} className={`me-2 text-${onClock ? "success" : "gray-500"}`} />
                {clock === undefined ? "Clock unknown" : onClock ? "On the clock" : "Off the clock"}
            </span>

            <span className="d-inline-flex align-items-center">
                <Icon icon="location-dot" type="regular" size={14} className={`me-2 text-${freshnessTone}`} />
                <TechLocationFreshnessLabel techId={techId} lastUpdate={lastUpdate} isWakeupAddress={isWakeup} noDot />
            </span>

            <span className="d-inline-flex align-items-center">
                <Icon icon="location-crosshairs" type="regular" size={14} className={`me-2 text-${accessTone}`} />
                <TechLocationAccessLabel techId={techId} noIcon compact />
            </span>

        </div>
    )
}
